<template>
    <div>
        <div v-if="is_linking">
            <h3 class="mt-2 mb-3" v-if="issue_type == 'material_damage'">Link Material Damage</h3>
        </div>
        <div v-else-if="report_mode">
            <h3 class="mt-2" v-if="issue_type == 'highway'">Corrective Maintenance Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'electrical_maintenance'">Electrical Maintenance Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'major_maintenance'">Major Maintenance Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'routine_maintenance'">Routine Maintenance Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'road_user_accident'">Road User Accident Issue Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'occupational'">Occupational Accident Issue Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'hazard'">Hazard Accident Issue Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'dead_animal_debris_removal'">Dead Animal Debris Removal Issue Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'vehicle_breakdown'">Vehicle Breakdown Issue Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'traffic_violation'">Traffic Violation Issue Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'unauthorised_parking'">Unauthorised Parking Issue Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'unauthorised_access'">Unauthorised Access Issue Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'unauthorised_media_cut'">Unauthorised Median Cut Issue Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'material_damage'">Material Damage Issue Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'other'">Other Issue Report</h3>
            <h3 class="mt-2" v-else-if="issue_type == 'enroachment_row'">Enroachment Row Issue Report</h3>
        </div>
        <div v-else>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="px-0 flex">
                    <h3 class="mt-2" v-if="issue_type == 'highway'">Corrective Maintenance</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'electrical_maintenance'">Electrical Maintenance</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'major_maintenance'">Major Maintenance</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'routine_maintenance'">Routine Maintenance</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'road_user_accident'">Road User Accident Issue</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'occupational'">Occupational Accident Issue</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'hazard'">Hazard Accident Issue</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'dead_animal_debris_removal'">Dead Animal Debris Removal Issue</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'vehicle_breakdown'">Vehicle Breakdown Issue</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'traffic_violation'">Traffic Violation Issue</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'unauthorised_parking'">Unauthorised Parking Issue</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'unauthorised_access'">Unauthorised Access Issue</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'unauthorised_media_cut'">Unauthorised Median Cut Issue</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'material_damage'">Material Damage Issue</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'other'">Other Issue</h3>
                    <h3 class="mt-2" v-else-if="issue_type == 'enroachment_row'">Enroachment Row Issue</h3>
                </vs-col>
            </vs-row>
        </div>
        
        <!-- checking view permission  -->
        <div v-if="(!report_mode && (viewIssue || viewResolution || viewExternalResolution)) || (report_mode && seeReport)">
            <vs-row>
                <vs-col vs-xs="12" vs-sm="10" vs-lg="10" class="px-0 pr-2 mb-base">
                    <vs-input
                        class="w-full"
                        placeholder="Type to Search"
                        v-model="filters.search"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="mb-base p-0">
                    <vx-tooltip text="Refresh Data" color="primary" >
                        <vs-button color="primary" type="filled" class="w-full" @click="init()" :disabled="loading">
                            <font-awesome-icon :icon="redoIcon" />
                        </vs-button>
                    </vx-tooltip>
                    <template v-if="!is_linking">
                        <template>
                            <vx-tooltip text="Create New Issue" color="primary" class="ml-2" v-if="!report_mode">
                                <router-link :to="{name: 'issues-new', params: {issue_type: issue_type}}">
                                    <vs-button color="primary" type="filled" class="w-full" :disabled="loading">
                                        <font-awesome-icon :icon="addIcon" />
                                    </vs-button>
                                </router-link>
                            </vx-tooltip>
                        </template>
                        <vx-tooltip text="Create Excel" color="primary" class="ml-2" v-if="(report_mode && seeReport)">
                            <vs-button color="primary" type="filled" @click="create_excel"  class="ml-2" :disabled="loading">
                                <font-awesome-icon :icon="excel" />
                            </vs-button>
                        </vx-tooltip>
                    </template>
                </vs-col>
            </vs-row>
    
            <vs-row>
                <!-- date range filter  -->
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                    <SelectDate :selectedDate.sync="filters[`${get_date_filter_key}__gte`]" label="Date From" />
                    <small class="block text-danger mt-1" v-if="api_errors && api_errors[`${get_date_filter_key}__gte`]">
                        {{ api_errors[`${get_date_filter_key}__gte`].join(', ') }}
                    </small>
                </vs-col>
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                    <SelectDate :selectedDate.sync="filters[`${get_date_filter_key}__lte`]" label="Date To" />
                    <small class="block text-danger mt-1" v-if="api_errors && api_errors[`${get_date_filter_key}__lte`]">
                        {{ api_errors[`${get_date_filter_key}__lte`].join(', ') }}
                    </small>
                </vs-col>
                <!-- Generic Filter For All  -->
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 mb-3 pr-3" v-if="!['occupational', 'hazard'].includes(this.issue_type)">
                    <InputSelect
                        :model.sync="filters.data__direction"
                        label="Filter By Direction"
                        placeholder="Choose ..."
                        container_class="w-auto input-custom-dropdown"
                        :options="direction_options"
                        :multiple="false"
                    />
                </vs-col>
                <!-- Generic Filter For All  -->
                <template v-if="['electrical_maintenance', 'major_maintenance', 'highway', 'routine_maintenance', 'material_damage', 'unauthorised_media_cut'].includes(this.issue_type)">
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                        <SelectForeign
                            :model.sync="filters.assigned_reviewers"
                            label="Filter By Maintenance Manager"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['first_name', 'last_name']"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="true"
                        />
                    </vs-col>
                </template>
                <template v-else>
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                        <SelectForeign
                            :model.sync="filters.assigned_reviewers"
                            label="Filter By Incident Manager"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['first_name', 'last_name']"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="true"
                        />
                    </vs-col>
                </template>
                <!-- Generic Filter For All  -->
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                    <SelectForeign
                        :model.sync="filters.reported_by"
                        label="Filter By Reporter"
                        placeholder="Type to Search..."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['first_name', 'last_name']"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.organisation_users}?is_active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="true"
                    />
                </vs-col>
                <!-- Filter For Unauthorised Parking, Vehicle BreakDown, Traffic Violation  -->
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3" v-if="['unauthorised_parking', 'vehicle_breakdown', 'traffic_violation'].includes(issue_type)">
                    <SelectForeign
                        :model.sync="filters.data__vehicle_type"
                        label="Filter By Vehicle Type"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_vehicle_types}?issue_type_category=${issue_type}&active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="true"
                    />
                </vs-col>
                <!-- Filter For RM, EM, MM, CM(highway), Hazard (Field Category)  -->
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3"
                    v-if="['routine_maintenance', 'major_maintenance', 'electrical_maintenance', 'highway', 'hazard'].includes(issue_type)">
                    <SelectForeign
                        :model.sync="filters.data__category"
                        label="Filter By Issue Category"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_categories}?issue_type_category=${issue_type}&active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="true"
                    />
                </vs-col>
                <!-- Filter For RM, EM, MM, CM(highway), (Field Authority Type)  -->
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3"
                    v-if="['routine_maintenance', 'major_maintenance', 'electrical_maintenance', 'highway'].includes(issue_type)">
                    <SelectForeign
                        :model.sync="filters.data__authority_type"
                        label="Filter By Authority Type"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_authority_types}?active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="true"
                    />
                </vs-col>
                <!-- Filter For Enroachment ROW, (Field Type of Enroachment)  -->
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3" v-if="issue_type == 'enroachment_row'">
                    <SelectForeign
                            :model.sync="filters.data__enroachment_type"
                            label="Filter By Enroachment Type"
                            placeholder="Type to Search.."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['name', ]"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.data_enroachment_types}?active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="true"
                        />
                </vs-col>
                <!-- Filter For Occupational (Field Accident Classification)  -->
                <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3" v-if="issue_type == 'occupational'">
                    <SelectForeign
                        :model.sync="filters.data__accident_classification"
                        label="Filter By Accident Classification"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['name', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.data_accident_classifications}?accident_type_category=occupational&active=true`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="true"
                    />
                </vs-col>
                <!-- Filter For Road User Accident -->
                <template v-if="issue_type == 'road_user_accident'">
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                        <SelectForeign
                            :model.sync="filters.data__nature_of_accident"
                            label="Filter By Accident Nature"
                            placeholder="Type to Search.."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['name', ]"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.data_nature_of_accidents}?active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="true"
                        />
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                        <SelectForeign
                            :model.sync="filters.data__classification_of_accident"
                            label="Filter By Accident Classification"
                            placeholder="Type to Search.."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['name', ]"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.data_accident_classifications}?accident_type_category=road_user_accident&active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="true"
                        />
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                        <SelectForeign
                            :model.sync="filters.data__road_feature"
                            label="Filter By Road Feature"
                            placeholder="Type to Search.."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['name', ]"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.data_road_features}?active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="true"
                        />
                    </vs-col>
                </template>
            </vs-row>
    
            <template v-if="report_mode && ongoing_exports.length && !is_linking">
                <vs-alert color="primary" v-if="loading_exports">
                    Loading Latest Exports, please wait..
                </vs-alert>
                <template v-else>
                    <template v-for="(item, index) in ongoing_exports">
                        <vs-alert color="primary" :key="index" class="mb-2">
                            <template v-if="item.status == 'p'">
                                Your export is pending, please check back in few minutes
                            </template>
                            <template v-else-if="item.status == 's'">
                                Your export is in queue, please check back in few minutes
                            </template>
                            <template v-else-if="item.status == 'r'">
                                Your export is being generated, please check back in few minutes
                            </template>
                            <template v-else-if="item.status == 'c'">
                                Your export has been completed. (<FormatText :text="item.created_on" format="datetime" />) <a :href="item.export_excel" target="_blank" style="float:right;"><vs-button size="small">Download</vs-button></a>
                            </template>
                            <template v-else-if="item.status == 'f'">
                                Your export has been failed, please request again!
                            </template>
                        </vs-alert>
                    </template>
                </template>
            </template>
            
            <template v-if="(viewIssue || viewResolution || viewExternalResolution)">
                <!-- list view -->
                <template v-if="is_linking">
                    <div class="vx-col w-full mt-3 mb-base">
                        <vx-card>
                            <MaterialDamageList :is_linking="true" @link="id => link_issue(id)" :report_mode="true" :results="results" slot="no-body" v-if="issue_type == 'material_damage'" />
                        </vx-card>
                    </div>
                </template>
                <template v-else>
                    <div class="vx-col w-full mt-3 mb-base">
                        <vx-card v-if="$store.state.windowWidth >= 768">
                            <HighwayList v-if="issue_type == 'highway'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <OccupationalList v-else-if="issue_type == 'occupational'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <HazardList v-else-if="issue_type == 'hazard'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <RoadUserAccidentList v-else-if="issue_type == 'road_user_accident'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <TrafficViolationList v-else-if="issue_type == 'traffic_violation'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <UnauthorisedAccessList v-else-if="issue_type == 'unauthorised_access'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <UnauthorisedMedianCutList v-else-if="issue_type == 'unauthorised_media_cut'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <UnauthorisedParkingList v-else-if="issue_type == 'unauthorised_parking'"  :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <VehicleBreakdownList v-else-if="issue_type == 'vehicle_breakdown'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <MaterialDamageList v-else-if="issue_type == 'material_damage'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <EnroachmentRowList v-else-if="issue_type == 'enroachment_row'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <DeadAnimalDebrisRemovalList v-else-if="issue_type == 'dead_animal_debris_removal'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <OtherList v-else-if="issue_type == 'other'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <ElectricalMaintenanceList v-else-if="issue_type == 'electrical_maintenance'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <MajorMaintenanceList v-else-if="issue_type == 'major_maintenance'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body" :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                            <RoutineMaintenanceList v-else-if="issue_type == 'routine_maintenance'" :report_mode="report_mode" :results="results" :delete_permission="delete_permission" 
                                :changeIssueAssignee="changeIssueAssignee" @do_delete="id => do_delete(id)" slot="no-body"  :manager_dropdown="manager_dropdown"
                                :editIssue="editIssue"
                            />
                        </vx-card>
                        <IssueMobileList v-else :results="results" :issue_type="issue_type" />
                    </div>
                </template>
                <DeletePopup :is_active.sync="delete_popup.active" type="issue" @delete_issue="delete_issue" />
        
                <!-- pagination  -->
                <template v-if="!disable_pagination">
                    <vs-row v-if="total_results" class="mt-3 text-center">
                        <vs-pagination :total="total_pages" v-model="current_page" goto class="mx-auto"></vs-pagination>
                    </vs-row>
                </template>
            </template>
        </div>
        <div v-else>
            <PermissionDenied />
        </div>
    </div>
</template>


<script>
import SelectDate from '../../components/letstream/ls-select-date/SelectDate.vue'
import { faPlus, faRedo, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { Request } from '../../utils/requests';

import HighwayList from './Highway/HighwayList.vue';
import OccupationalList from './Occupational/OccupationalList.vue';
import HazardList from './Hazard/HazardList.vue';
import RoadUserAccidentList from './RoadUserAccident/RoadUserAccidentList.vue';
import UnauthorisedAccessList from './UnauthorisedAccess/UnauthorisedAccessList.vue';
import UnauthorisedMedianCutList from './UnauthorisedMedianCut/UnauthorisedMedianCutList.vue';
import UnauthorisedParkingList from './UnauthorisedParking/UnauthorisedParkingList.vue';
import VehicleBreakdownList from './VehicleBreakDown/VehicleBreakdownList.vue';
import MaterialDamageList from './MaterialDamage/MaterialDamageList.vue';
import EnroachmentRowList from './EnroachmentRow/EnroachmentRowList.vue';
import DeadAnimalDebrisRemovalList from './DeadAnimalDebrisRemoval/DeadAnimalDebrisRemovalList.vue';
import OtherList from './Other/OtherList.vue';
import TrafficViolationList from './TrafficViolation/TrafficViolationList.vue';
import ElectricalMaintenanceList from './ElectricalMaintenance/ElectricalMaintenanceList.vue';
import MajorMaintenanceList from './MajorMaintenance/MajorMaintenanceList.vue';
import RoutineMaintenanceList from './RoutineMaintenance/RoutineMaintenanceList.vue';

import IssueMobileList from "./IssueMobileList.vue"
import DeletePopup from '../components/DeletePopup.vue';

import moment from 'moment';

export default {
	props: {
        embedded_mode: {
            required: false,
            default: false
        },
        embedded_filters: {
            required: false,
            default: () => {}
        },
        disable_pagination: {
            required: false,
            default: false
        },
        global_mode: {
            required: false,
            type: Boolean,
            default: false
        },
        report_mode: {
            required: false,
            type: Boolean,
            default: false
        },
        is_linking: {
            required: false,
            type: Boolean,
            default: false
        },
    },
    components: {
        HighwayList,
        OccupationalList,
        HazardList,
        RoadUserAccidentList,
        TrafficViolationList,
        UnauthorisedAccessList,
        UnauthorisedMedianCutList,
        UnauthorisedParkingList,
        VehicleBreakdownList,
        MaterialDamageList,
        EnroachmentRowList,
        DeadAnimalDebrisRemovalList,
        OtherList,
        IssueMobileList,
        ElectricalMaintenanceList,
        MajorMaintenanceList,
        RoutineMaintenanceList,
        SelectDate,
        DeletePopup
    },
    data() {
        let offset = parseInt(this.$route.query.offset || 0);
        let limit = parseInt(this.$route.query.limit || 20);

        let current_page = Math.ceil((offset + limit) / limit);
        return  {
            issue_type: this.$route.params.issue_type,
            results: [],

			next_url: null,
            loading: false,
            total_results: null,
            current_page: current_page,
            filters: {
                search: this.$route.query.search || null,
                ordering: this.$route.query.ordering || [],
                offset: offset,
                limit: limit,
            },

            filters_init: false,

            // filters
            direction_options: [
                {value: 'median', label: "Median"},
                {value: 'bhs', label: "BHS"},
                {value: 'rhs', label: "RHS"},
                {value: 'lhs', label: "LHS"},
            ],

            reject_popup: {
                active: false,
                comment: null,
                item: null,
                api_errors: {}
            },

            delete_popup: {
                active: false,
                id: null
            },

            submit_disabled: false,
            api_errors: {},

            loading_exports: false,
            ongoing_exports: [],

            issue_date: [
                'routine_maintenance', 
                'electrical_maintenance', 
                'major_maintenance', 
                'highway', 
                'occupational', 
                'hazard', 
                'dead_animal_debris_removal', 
                'vehicle_breakdown', 
                'unauthorised_access', 
                'unauthorised_media_cut', 
                'material_damage',  
                'enroachment_row'
            ],

            issue_date_of_accident: [
                'road_user_accident',
                'other',
                'traffic_violation'
            ]
        }
    },
    mounted() {
        this.init()
    },
	computed: {
        total_pages() {
            if(this.total_results == 0 || this.filters.limit == 0)  return 1
            return Math.ceil(this.total_results/this.filters.limit)
        },
        redoIcon: () => faRedo,
        addIcon: () => faPlus,
        excel: () => faFileExcel,
        viewIssue() { 
            return this.hasAccess('read', `issue_${this.issue_type}`, 'any')
        },
        viewResolution() { 
            return this.hasAccess('read_resolution', `issue_${this.issue_type}`, ['all', 'assigned'])
        },
        viewExternalResolution() {
            return this.hasAccess('read_external_resolution', `issue_${this.issue_type}`, ['all', 'assigned'])
        },
        seeReport() {
            return this.hasAccess('read', `issue_${this.issue_type}_report`, 'all')
        },
        get_date_filter_key() {
            if (this.issue_date.includes(this.issue_type)) {
                return 'data__date'
            } else if (this.issue_date_of_accident.includes(this.issue_type)) {
                return 'data__date_of_accident'
            } else {
                return 'created_on__date'
            }
        }
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {
                if (!this.filters_init) return

                if (this.current_page == null) return;

                if (this.timer) clearTimeout(this.timer);

                this.timer = setTimeout(() => {
                    this.$router.push({ name: this.$route.name, query: {...newV, ...this.embedded_query_params} });
                }, 800);
            }
        },
        issue_type() {
            this.load_filters()
            if (this.report_mode)
                this.refresh_exports()
        },
        report_mode(newV) {
            if (newV) this.refresh_exports()
        },
        "$route.query"(newV) {
            if ((this.viewIssue || this.viewResolution || this.viewExternalResolution)) {
                this.load_data(newV);
            }
        },
        current_page(newV, oldV) {
            if (newV == oldV) return;
            this.filters.offset = (newV - 1) * this.filters.limit;
        },
        '$route.params.issue_type'() {
            this.init()
        }
    },
    beforeDestroy() {
        if (this.export_timer) clearTimeout(this.export_timer)
    },
    methods: {
        init(){
            this.issue_type = this.$route.params.issue_type
            this.load_filters()
            // this.load_data(this.filters)
        },
        refresh_exports() {
            this.loading_exports = true

            let url = this.$store.state.apiendpoints.excel_list

            let payload = {
                created_on: moment().format('YYYY-MM-DD'),
                module_key: 'i',
                params__issue_type: this.issue_type,
                limit: 4
            }

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.ongoing_exports = res.results
                    this.loading_exports = false
                    if(this.ongoing_exports.filter((item) => ['p', 's', 'r'].includes(item.status)).length != 0) this.auto_refresh_export()
                }, 
                (err) => {
                    this.loading_exports = false;
                    this.$vs.notify({
                        time: 2500,
                        title: 'Error',
                        text: "Unable to load current exports, please refresh to try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        auto_refresh_export() {
            this.export_timer = setTimeout(() => {
                this.refresh_exports()
            }, 5000);
        },
        create_excel() {

            this.loading = true;
            this.$vs.loading();

            let corrected_keys = {}

            Object.keys(this.filters).filter((key) => !['search', 'ordering', 'offset', 'limit'].includes(key) && this.filters[key]).forEach(key => {
                corrected_keys[key] = this.filters[key]
            })

            let payload = {
                module_key: 'i',
                params: {
                    "issue_type": this.issue_type,
                    "filters": corrected_keys
                }
            }

            let url = this.$store.state.apiendpoints.excel_create

            Request(this, 'POST', url, null, payload).then(
                (res) => {
                    this.loading = false;
                    this.$vs.loading.close();

                    this.refresh_exports()

                    this.$vs.notify({
                        time: 3000,
                        title: 'Success',
                        text: "Your request to download file has been submitted",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                (err) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    if (err.error) {
                        this.api_errors = err.error

                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )


        },
        load_filters() {

            if (this.is_linking) {
                this.filters_init = true
                return
            }

            this.filters_init = false
            this.filters = {
                search: this.filters.search,
                ordering: this.filters.ordering,
                offset: this.filters.offset,
                limit: this.filters.limit,
                assigned_reviewers: null,
                reported_by: null,
            }

            // date filters
            let date_key = this.get_date_filter_key
            this.$set(this.filters, `${date_key}__gte`, this.$route.query[`${date_key}__gte`] || null)
            this.$set(this.filters, `${date_key}__lte`, this.$route.query[`${date_key}__lte`] || null)

            if (!['occupational', 'hazard'].includes(this.issue_type)) {
                this.$set(this.filters, 'data__direction', this.$route.query.data__direction || null)
            }

            if (['unauthorised_parking', 'vehicle_breakdown', 'traffic_violation'].includes(this.issue_type)) {
                this.$set(this.filters, 'data__vehicle_type', this.$route.query.data__vehicle_type || null)

            } else if (['routine_maintenance', 'major_maintenance', 'electrical_maintenance', 'highway'].includes(this.issue_type)) {
                this.$set(this.filters, 'data__category', this.$route.query.data__category || null)
                this.$set(this.filters, 'data__authority_type', this.$route.query.data__authority_type || null)

            } else if (this.issue_type == 'hazard') {
                this.$set(this.filters, 'data__category', this.$route.query.data__category || null)

            } else if (this.issue_type == 'enroachment_row') {
                this.$set(this.filters, 'data__enroachment_type', this.$route.query.data__enroachment_type || null)

            } else if (this.issue_type == 'occupational') {
                this.$set(this.filters, 'data__accident_classification', this.$route.query.data__accident_classification || null)

            } else if (this.issue_type == 'road_user_accident') {
                this.$set(this.filters, 'data__nature_of_accident', this.$route.query.data__nature_of_accident || null)
                this.$set(this.filters, 'data__classification_of_accident', this.$route.query.data__classification_of_accident || null)
                this.$set(this.filters, 'data__road_feature', this.$route.query.data__road_feature || null)
                this.$set(this.filters, 'data__vehicle_responsible', this.$route.query.data__vehicle_responsible || null)

            }

            this.filters_init = true
        },
        calculate_page() {
            if (this.filters.offset == 0) this.current_page = 1;
            else
                this.current_page = Math.ceil(this.filters.offset / this.filters.limit);
        },
        load_data(filters=null) {

            this.api_errors = {}

            let date_key = this.get_date_filter_key
            // checking for date range filters
            if (filters[`${date_key}__gte`] && !filters[`${date_key}__lte`]) {
                this.api_errors[date_key + '__lte'] = [
                    "Date To should be there.",
                ]
                return

            } else if(filters[`${date_key}__lte`] && !filters[`${date_key}__gte`]) {
                this.api_errors[date_key + '__gte'] = [
                    "Date From should be there.",
                ]
                return
            }

            this.loading = true;
            this.$vs.loading();

            let url = this.$store.state.apiendpoints.data_issues

            let payload = filters

            if (!payload) payload = {};

            if (this.embedded_mode && this.embedded_filters) {
                payload = { ...payload, ...this.embedded_filters };
            }

            if (this.global_mode) {
                payload['global'] = true
            }

            payload['issue_type'] = this.$route.params.issue_type

            if (this.is_linking) payload['linked_only'] = false

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.results = res.results
                    this.total_results = res.count
                    this.next_url = res.next;
                    this.loading = false;
                    this.$vs.loading.close();
                    if(this.report_mode) this.refresh_exports()
                },
                (err) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    if (err.error) {
                        this.api_errors = err.error

                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Unable to load Pipelines. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        link_issue(id) {

            this.loading = true;
            this.$vs.loading();

            let url = this.$store.state.apiendpoints.data_issue + id + '/'
            let payload = {
                link_issue: this.$route.params.issue_id
            }

            Request(this, 'PATCH', url, null, payload).then(
                (res) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    this.$vs.notify({
                        time: 3000,
                        title: 'Saved',
                        text: "Linked Successfully",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    if (this.$route.query.next) {
                        this.$router.push(this.$route.query.next)

                    } else {
                        this.$router.push({name: 'issues-list', params: {issue_type: this.$route.query.issue_type}})
                    }
                },
                (err) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    if (err.error) {
                        this.api_errors = err.error

                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        do_delete(id) {
            this.delete_popup.active = true
            this.delete_popup.id = id
        },
        delete_issue() {

            let url = this.$store.state.apiendpoints.data_issue + this.delete_popup.id + "/"
            this.disabled = true

            Request(this, 'DELETE', url, null, null).then(
                (res) => {
                    // after successful deletion removing from results
                    this.results = this.results.filter(obj => obj.id != this.delete_popup.id)
                    this.delete_popup.active = false
                    this.delete_popup.id = null
                    this.disabled = false
                    this.$vs.loading.close()
                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: 'Issue deleted successfully.',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                (err) => {
                    this.delete_popup.active = false
                    this.delete_popup.id = null
                    this.disabled = false
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        deleteIssuePermission(item) {
            let user_ids = item.assigned_reviewers.map(v=>v.id)
            user_ids.push(item.reported_by.id)

            return this.hasAccess('delete', `issue_${item.issue_type}`, 'any', user_ids)
        },
        delete_permission(item) {
            if(!this.deleteIssuePermission(item)) return false

            const issue_month = (new Date(item.created_on)).getMonth()
            const current_month = (new Date()).getMonth()

            if(issue_month==current_month) return true

            return false
        },
        changeIssueAssignee(item) { 
            return this.hasAccess('edit', `issue_${item.issue_type}`, ['all', 'own'], [item.reported_by.id]) 
        },
        manager_dropdown() {
            let permission = []
            permission.push(`review__all__issue_${this.issue_type}`)
            permission.push(`review__assigned__issue_${this.issue_type}`)

            return permission.toString()
        },
        editIssue(item) { 
            return this.hasAccess('edit', `issue_${item.issue_type}`, ['all', 'own'], [item.reported_by.id])
        }
    }
}

</script>
